import React, { useState, useEffect, useCallback } from "react";
import "./Gallery.css";
import { Link } from "react-router-dom";
import PageSEO from "../../SEO/PageSEO";
import heroGalleryImg from "../../../images/corporate-health-assessment-uganda.jpeg";

// ── Uncomment these imports once the new WhatsApp images have been renamed
// using rename-new-images.sh and placed in src/images/
//
// import outdoorConsult  from "../../../images/yitalife-team-outdoor-consultation.jpeg";
// import doctorPatient   from "../../../images/yitalife-doctor-patient-consultation.jpeg";
// import campImg         from "../../../images/yitalife-community-health-camp-uganda.jpeg";
// import screeningImg    from "../../../images/yitalife-free-health-screening-uganda.jpeg";
// import maternalNew     from "../../../images/yitalife-maternal-health-service-uganda.jpeg";
// import homeVisitNew    from "../../../images/yitalife-home-visit-patient-care.jpeg";
// import outreachNew     from "../../../images/yitalife-medical-outreach-kampala.jpeg";
// import corporateNew    from "../../../images/yitalife-corporate-health-team.jpeg";
// import clinicNew       from "../../../images/yitalife-community-clinic-uganda.jpeg";
// import professionalsImg from "../../../images/yitalife-medical-professionals-uganda.jpeg";
// import eduNew          from "../../../images/yitalife-health-education-community.jpeg";
//
// Then add these to allImages array:
// { src: outdoorConsult,   cat: "team",     caption: "Yitalife team outdoor consultation - Kampala Uganda" },
// { src: doctorPatient,    cat: "services", caption: "Yitalife doctor consulting a patient at home - Uganda" },
// { src: campImg,          cat: "outreach", caption: "Yitalife community health camp - free medical services Uganda" },
// { src: screeningImg,     cat: "outreach", caption: "Free health screening at Yitalife community camp - Uganda" },
// { src: maternalNew,      cat: "services", caption: "Yitalife maternal health service - antenatal care Uganda" },
// { src: homeVisitNew,     cat: "services", caption: "Yitalife home visit - doctor attending to patient at home" },
// { src: outreachNew,      cat: "outreach", caption: "Yitalife medical outreach - Kampala Uganda" },
// { src: corporateNew,     cat: "services", caption: "Yitalife corporate health team - staff medical assessment Uganda" },
// { src: clinicNew,        cat: "outreach", caption: "Yitalife community clinic - quality care in Uganda" },
// { src: professionalsImg, cat: "team",     caption: "Yitalife qualified medical professionals - Uganda" },
// { src: eduNew,           cat: "outreach", caption: "Yitalife health education - community awareness Uganda" },

const allImages = [
  // ── Team & staff ──
  {
    src: require("../../../images/medical-team-yitalife-kampala.jpeg"),
    cat: "team",
    caption:
      "Yitalife medical team ready to serve patients across Kampala, Uganda",
  },
  {
    src: require("../../../images/7294348d-f284-40bf-8e62-295d3c85d0de.jpeg"),
    cat: "team",
    caption: "Yitalife healthcare professionals - qualified doctors and nurses",
  },
  {
    src: require("../../../images/d7b94117-07ca-4993-a02d-8d84322a3876.jpeg"),
    cat: "team",
    caption: "Yitalife clinical staff - committed to patient-centred care",
  },
  {
    src: require("../../../images/leadership-board-yitalife.jpeg"),
    cat: "team",
    caption:
      "Yitalife leadership - Yita Medical Services board and management team",
  },
  {
    src: require("../../../images/photo_5976566633449243953_y.jpg"),
    cat: "team",
    caption: "Our dedicated Yitalife medical team in the field",
  },

  // ── Home & clinical services ──
  {
    src: require("../../../images/home-doctor-visit-uganda.jpeg"),
    cat: "services",
    caption: "Yitalife doctor conducting a home visit in Uganda",
  },
  {
    src: require("../../../images/hospital-at-home-care-uganda.jpeg"),
    cat: "services",
    caption: "Hospital at home care - nursing and bedside services by Yitalife",
  },
  {
    src: require("../../../images/maternal-care-antenatal-uganda.jpeg"),
    cat: "services",
    caption: "Antenatal and maternal care at home - Yitalife Uganda",
  },
  {
    src: require("../../../images/corporate-health-assessment-uganda.jpeg"),
    cat: "services",
    caption: "Corporate health assessment and staff medical check by Yitalife",
  },
  {
    src: require("../../../images/telemedicine-consultation-uganda.jpeg"),
    cat: "services",
    caption:
      "Telemedicine consultation - online doctor visit by Yitalife Uganda",
  },
  {
    src: require("../../../images/chronic-disease-followup-uganda.jpeg"),
    cat: "services",
    caption: "Chronic disease follow-up and home-based care by Yitalife",
  },
  {
    src: require("../../../images/school-medical-exams-uganda.jpeg"),
    cat: "services",
    caption: "School student medical examination by Yitalife Uganda",
  },
  {
    src: require("../../../images/remote-patient-monitoring-uganda.jpeg"),
    cat: "services",
    caption: "Remote patient monitoring technology - Yitalife Uganda",
  },

  // ── Community outreach ──
  {
    src: require("../../../images/community-health-outreach-kampala.jpeg"),
    cat: "outreach",
    caption:
      "Yitalife community health outreach and free medical camp - Kampala Uganda",
  },
  {
    src: require("../../../images/yitag.jpg"),
    cat: "outreach",
    caption:
      "Yitalife community outreach programme - bringing healthcare to the people",
  },
  {
    src: require("../../../images/photo_5976566633449243966_y.jpg"),
    cat: "outreach",
    caption: "Kawempe medical camp - free screenings by Yitalife",
  },
  {
    src: require("../../../images/photo_5976566633449243979_y.jpg"),
    cat: "outreach",
    caption: "Free health screening for community members - Yitalife outreach",
  },
  {
    src: require("../../../images/photo_5976566633449243975_y.jpg"),
    cat: "outreach",
    caption: "Outdoor healthcare services at a community medical camp",
  },
  {
    src: require("../../../images/taxi2.jpg"),
    cat: "outreach",
    caption: "UTOF taxi driver health camp - Yitalife partnership programme",
  },
  {
    src: require("../../../images/taxi3.jpg"),
    cat: "outreach",
    caption: "Medical services for taxi drivers - Yitalife community health",
  },
  {
    src: require("../../../images/taxi4.jpg"),
    cat: "outreach",
    caption: "Doctor consultations at the taxi park - Yitalife UTOF initiative",
  },
  {
    src: require("../../../images/photo_5976566633449243988_y.jpg"),
    cat: "outreach",
    caption: "Medical camp activities - Yitalife community healthcare",
  },
  {
    src: require("../../../images/photo_5976566633449243961_y.jpg"),
    cat: "outreach",
    caption: "Health education for the community - Yitalife outreach Uganda",
  },
  {
    src: require("../../../images/photo_5976566633449243967_y.jpg"),
    cat: "outreach",
    caption: "Free screenings for community members - Yitalife Uganda",
  },
  {
    src: require("../../../images/photo_5976566633449243969_y.jpg"),
    cat: "outreach",
    caption: "Preventive healthcare outreach - Yitalife Uganda",
  },
  {
    src: require("../../../images/photo_5976566633449243989_y.jpg"),
    cat: "outreach",
    caption: "Community health awareness - Yitalife Uganda",
  },
  {
    src: require("../../../images/photo_5976566633449243971_y.jpg"),
    cat: "outreach",
    caption: "Health promotion at community level - Yitalife",
  },
  {
    src: require("../../../images/m1.jpeg"),
    cat: "outreach",
    caption: "Mawokota-Mpigi free medical camp - Yitalife community health",
  },
  {
    src: require("../../../images/m2.jpeg"),
    cat: "outreach",
    caption: "NCD & sickle cell screening - Mawokota-Mpigi health camp",
  },
  {
    src: require("../../../images/m3.jpeg"),
    cat: "outreach",
    caption: "Diabetes & hypertension screening - Yitalife Mpigi outreach",
  },
  {
    src: require("../../../images/m4.jpeg"),
    cat: "outreach",
    caption: "Prostate cancer screening at Mawokota community health camp",
  },
  {
    src: require("../../../images/m5.jpeg"),
    cat: "outreach",
    caption: "Free treatment at Mawokota-Mpigi medical camp - Yitalife",
  },
  {
    src: require("../../../images/m6.jpeg"),
    cat: "outreach",
    caption: "Community members receiving care - Yitalife Mpigi health camp",
  },
  {
    src: require("../../../images/m7.jpeg"),
    cat: "outreach",
    caption: "Medical team at work - Mawokota-Mpigi free health camp",
  },
  {
    src: require("../../../images/m8.jpeg"),
    cat: "outreach",
    caption: "Health education session - Yitalife Mpigi outreach programme",
  },
  {
    src: require("../../../images/m9.jpeg"),
    cat: "outreach",
    caption: "Consultations at Mawokota-Mpigi camp - Yitalife Uganda",
  },

  // ── Events ──
  {
    src: require("../../../images/yitaj.jpg"),
    cat: "events",
    caption: "Yitalife health event and awareness programme",
  },
  {
    src: require("../../../images/yitz1.jpg"),
    cat: "events",
    caption: "Yitalife health awareness event - Uganda",
  },
];

const filters = [
  { key: "all", label: "All Photos" },
  { key: "services", label: "Our Services" },
  { key: "outreach", label: "Community Outreach" },
  { key: "team", label: "Our works" },
  { key: "events", label: "Events" },
];

const Gallery = () => {
  const [activeFilter, setActiveFilter] = useState("all");
  const [selectedIndex, setSelectedIndex] = useState(null);

  const filtered =
    activeFilter === "all"
      ? allImages
      : allImages.filter((img) => img.cat === activeFilter);

  const openModal = (i) => setSelectedIndex(i);
  const closeModal = () => setSelectedIndex(null);

  const nextImage = useCallback(
    () =>
      setSelectedIndex((prev) => (prev === filtered.length - 1 ? 0 : prev + 1)),
    [filtered.length],
  );

  const prevImage = useCallback(
    () =>
      setSelectedIndex((prev) => (prev === 0 ? filtered.length - 1 : prev - 1)),
    [filtered.length],
  );

  useEffect(() => {
    const onKey = (e) => {
      if (selectedIndex === null) return;
      if (e.key === "Escape") closeModal();
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [selectedIndex, nextImage, prevImage]);

  useEffect(() => {
    setSelectedIndex(null);
  }, [activeFilter]);

  return (
    <div>
      <PageSEO
        title="Photo Gallery - Yitalife Community Outreach & Services"
        description="Browse Yitalife's photo gallery - community medical camps, home doctor visits, outreach programmes, and team photos from Yita Medical Services across Uganda."
        canonical="https://www.yitalife.com/Gallery"
      />

      {/* ── HERO ── */}
      <div className="page-hero" style={{ backgroundImage: `url(${heroGalleryImg})` }}>
        <div className="container page-hero-content">
          <h1 data-aos="fade-down">Photo Gallery</h1>
          <p data-aos="fade-up" data-aos-delay="80">
            Moments from our community outreach, services, and healthcare
            programmes
          </p>
          <div className="page-breadcrumb">
            <Link to="/">Home</Link>
            <ion-icon
              name="chevron-forward-outline"
              style={{ fontSize: "13px" }}
            ></ion-icon>
            <span>Gallery</span>
          </div>
        </div>
      </div>

      {/* ── GALLERY ── */}
      <div className="gallery-page">
        <div className="container">
          {/* Header */}
          <div className="gallery-page-header" data-aos="fade-up">
            <div className="badge-yita" style={{ margin: "0 auto 14px" }}>
              <ion-icon name="images-outline"></ion-icon>
              Our Gallery
            </div>
            <h2>Yitalife in Action</h2>
            <p>
              Browse photos from our medical camps, home visits, community
              outreach, and healthcare programmes across Uganda.
            </p>
          </div>

          {/* Filter Tabs */}
          <div
            className="gallery-filters"
            data-aos="fade-up"
            data-aos-delay="80"
          >
            {filters.map((f) => (
              <button
                key={f.key}
                className={`gallery-filter-btn${activeFilter === f.key ? " active" : ""}`}
                onClick={() => setActiveFilter(f.key)}
                aria-pressed={activeFilter === f.key}
              >
                {f.label}
              </button>
            ))}
          </div>

          {/* Grid */}
          <div className="gallery-grid">
            {filtered.map((image, index) => (
              <div
                key={index}
                className="gallery-item"
                onClick={() => openModal(index)}
                role="button"
                tabIndex={0}
                aria-label={`View: ${image.caption}`}
                onKeyDown={(e) => e.key === "Enter" && openModal(index)}
                data-aos="zoom-in"
                data-aos-delay={Math.min(index * 35, 350)}
              >
                <img src={image.src} alt={image.caption} loading="lazy" />
                <div className="gallery-item-overlay">
                  <ion-icon
                    name="expand-outline"
                    className="gallery-zoom-icon"
                  ></ion-icon>
                </div>
              </div>
            ))}
          </div>

          <div className="gallery-count" aria-live="polite">
            Showing {filtered.length} of {allImages.length} photos
          </div>
        </div>
      </div>

      {/* ── LIGHTBOX ── */}
      {selectedIndex !== null && (
        <div
          className="gallery-modal"
          onClick={closeModal}
          role="dialog"
          aria-modal="true"
          aria-label="Photo lightbox"
        >
          <div
            className="gallery-modal-inner"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="gallery-modal-close"
              onClick={closeModal}
              aria-label="Close lightbox"
            >
              <ion-icon name="close-outline"></ion-icon>
            </button>
            <img
              src={filtered[selectedIndex].src}
              alt={filtered[selectedIndex].caption}
            />
            {filtered[selectedIndex].caption && (
              <div className="gallery-caption">
                {filtered[selectedIndex].caption}
              </div>
            )}
            <div className="gallery-modal-nav">
              <button
                className="gallery-nav-btn"
                onClick={prevImage}
                aria-label="Previous photo"
              >
                <ion-icon name="chevron-back-outline"></ion-icon> Previous
              </button>
              <button
                className="gallery-nav-btn"
                onClick={nextImage}
                aria-label="Next photo"
              >
                Next <ion-icon name="chevron-forward-outline"></ion-icon>
              </button>
            </div>
            <div className="gallery-counter">
              {selectedIndex + 1} / {filtered.length}
            </div>
          </div>
        </div>
      )}

      {/* ── CTA STRIP ── */}
      <section className="gallery-cta-strip">
        <div className="container">
          <h3 data-aos="fade-up">See Yitalife in Action</h3>
          <p data-aos="fade-up" data-aos-delay="60">
            Follow our social media channels for live updates from the field.
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "14px",
              flexWrap: "wrap",
            }}
            data-aos="fade-up"
            data-aos-delay="120"
          >
            <a
              href="https://x.com/yitalife"
              target="_blank"
              rel="noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                background: "#1d9bf0",
                color: "white",
                padding: "12px 24px",
                borderRadius: "40px",
                fontFamily: "Inter, sans-serif",
                fontWeight: 700,
                fontSize: "14px",
                textDecoration: "none",
              }}
            >
              <ion-icon name="logo-twitter"></ion-icon> Twitter / X
            </a>
            <a
              href="https://www.facebook.com/yitalife.yms?mibextid=LQQJ4d"
              target="_blank"
              rel="noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                background: "#1877f2",
                color: "white",
                padding: "12px 24px",
                borderRadius: "40px",
                fontFamily: "Inter, sans-serif",
                fontWeight: 700,
                fontSize: "14px",
                textDecoration: "none",
              }}
            >
              <ion-icon name="logo-facebook"></ion-icon> Facebook
            </a>
            <Link
              to="/Activity"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                background: "rgba(255,255,255,0.1)",
                color: "white",
                padding: "12px 24px",
                borderRadius: "40px",
                fontFamily: "Inter, sans-serif",
                fontWeight: 700,
                fontSize: "14px",
                border: "1.5px solid rgba(255,255,255,0.3)",
                textDecoration: "none",
              }}
            >
              <ion-icon name="newspaper-outline"></ion-icon> Read Our Activities
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
